// @flow

import { CNBC_IS_ADMIN_BACKEND_NAME, SG_CNBC_ID_PREFIX } from '../common/sgcnbc/constants';
import {
  CREDITS_AND_BURSTS_CONFIG_ARRAY_BACKEND_NAME,
  CREDITS_AND_BURSTS_JSON_BACKEND_NAME,
  IS_SGCNBC,
} from '../../constants';

export const getIfCNBCRowIsAdmin = (rowValues) => {
  return rowValues?.[CNBC_IS_ADMIN_BACKEND_NAME] === true;
};

export const getIfCNBCRowIsSG = (rowValues) => {
  return rowValues?.[IS_SGCNBC] === true;
};

export const getIsNetNewCustomer = (estimate) => {
  return estimate?.inputs?.net_new_customer === true;
};

export const getIfElemRepresentsASGCNBCRow = (elem) => {
  const cnbcId = elem?.id;
  return cnbcId && cnbcId.startsWith(SG_CNBC_ID_PREFIX);
};

// With extra padding when no cnbc rows exists, UI looks bit odd,
// so we're using this utility to get the padding based on the number of rows.
export const getCNBCGridPaddingLeftBasedOnTheNumberOfRows = (formikValues) => {
  const cnbcRows =
    formikValues?.[CREDITS_AND_BURSTS_JSON_BACKEND_NAME]?.[
      CREDITS_AND_BURSTS_CONFIG_ARRAY_BACKEND_NAME
    ] || [];
  const hasCNBCRows = cnbcRows.length > 0;
  // Use extra padding when rows exist, default padding when empty
  return hasCNBCRows ? '3rem' : '1.5rem';
};
